import React from 'react'
import ArCompanyRow from './ArCompanyRow'
import { IconChevronUp, IconChevronDown } from './ArIcons'
import { companyKeyOf } from './arAgingKeys'

const SortChevron = ({ active, dir }) => {
  if (!active) return null
  return <span className="ar-sort-chev">{dir === 'asc' ? <IconChevronUp size={10} /> : <IconChevronDown size={10} />}</span>
}

// Left column: sortable header, bulk-action bar (when ≥1 checked), company rows.
const ArCompanyList = ({
  companies, sort, onSort, selectedKey, checkedKeys, excludedKeys, ptpByCompany,
  openMenuKey, onSelect, onToggleCheck, onToggleMenu, actionsFor, bulkActions, onClearChecked
}) => {
  const checkedCount = checkedKeys.size

  return (
    <section className="ar-list">
      {checkedCount > 0 && (
        <div className="ar-bulk-bar">
          <span className="ar-bulk-count">{checkedCount} SELECTED</span>
          {bulkActions.map((action, index) => (
            <button key={index} type="button" className="ar-bulk-btn" onClick={action.run}>{action.label}</button>
          ))}
          <button type="button" className="ar-bulk-btn" onClick={onClearChecked}>Clear</button>
        </div>
      )}

      <div className="ar-list-head">
        <span className="ar-lh-check" />
        <button type="button" className="ar-lh-sortable" onClick={() => onSort('name')}>
          COMPANY <SortChevron active={sort.key === 'name'} dir={sort.dir} />
        </button>
        <span className="ar-lh-mix">AGING MIX</span>
        <button type="button" className="ar-lh-sortable ar-lh-pastdue" onClick={() => onSort('pastDue')}>
          PAST DUE <SortChevron active={sort.key === 'pastDue'} dir={sort.dir} />
        </button>
        <span className="ar-lh-kebab" />
      </div>

      {companies.length === 0 && (
        <div className="ar-list-empty">No companies match the current filters.</div>
      )}

      {companies.map(company => {
        const key = companyKeyOf(company)
        return (
          <ArCompanyRow
            key={key}
            company={company}
            selected={selectedKey === key}
            checked={checkedKeys.has(key)}
            excluded={excludedKeys.has(key)}
            ptp={ptpByCompany[company.companyId]}
            menuOpen={openMenuKey === key}
            onSelect={onSelect}
            onToggleCheck={onToggleCheck}
            onToggleMenu={onToggleMenu}
            actions={actionsFor(company)}
          />
        )
      })}
    </section>
  )
}

export default ArCompanyList
